import React from 'react';
const modules = [{
  title: 'Reactive Dog Psychology™',
  description: 'The professional framework for understanding the neurological and emotional roots of reactive behavior — including the science of the amygdala, cortisol flooding, and counter-conditioning — so you approach every dog from a place of knowledge, not guesswork.'
}, {
  title: 'Training Technique Library™',
  description: '150+ trainer-tested exercises, protocols, and progressions for every level — from basic attention and impulse control to advanced real-world threshold management and off-leash reliability.'
}, {
  title: 'Session Builder System™',
  description: 'Build structured training sessions in minutes using proven templates, warm-up systems, core protocol frameworks, and cool-down sequences that consolidate learning and lower arousal after every session.'
}, {
  title: 'Ready-To-Use Protocols™',
  description: 'Complete training protocols for puppies, adult dogs, fearful dogs, reactive dogs, and multi-dog households — ready to implement immediately without hours of preparation.'
}, {
  title: 'Progressive Training Programs™',
  description: '4-week, 8-week, and 12-week behavior modification programs that keep dogs improving session after session — with built-in assessment points so you always know what to do next.'
}, {
  title: 'Trainer Mastery™',
  description: 'Teaching cues, error correction strategies, owner communication frameworks, client motivation tools, and session management systems to train and coach with total professional confidence.'
}];
export function ModulesSection() {
  return <section className="py-7 px-4 sm:px-6 bg-brand-green text-white" data-id="element-100">
      <div className="text-center mb-5" data-id="element-101">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-white mb-2 uppercase leading-tight" data-id="element-102">
          THE SOLUTION YOU'VE BEEN LOOKING FOR — A COMPLETE 6-IN-1 SYSTEM
        </h2>
        <p className="text-sm sm:text-base font-bold text-brand-gold mb-3" data-id="element-103">
          6 professional modules in 1 complete training system
        </p>
        <div className="inline-block bg-brand-orange text-white px-3 py-1 rounded mb-3 shadow-sm" data-id="element-104">
          <p className="font-bold text-xs tracking-wide uppercase" data-id="element-105">
            🐾 DOG TRAINER PRO™ — 6-in-1 Complete Box Set
          </p>
        </div>
        <p className="text-sm text-white/90 leading-snug max-w-xl mx-auto" data-id="element-106">
          DOG TRAINER PRO™ is much more than a collection of exercises and
          drills. It is a complete professional operating system designed to
          help you deliver safer, more structured, and more effective dog
          training sessions — for every reactivity type, every breed, every age,
          and every environment.
        </p>
      </div>

      <div className="flex flex-col gap-2.5" data-id="element-107">
        {modules.map((module, i) => <div key={i} className="bg-white text-brand-ink p-3.5 rounded-md flex gap-3 items-start shadow-sm" data-id="element-108">
            <div className="text-brand-green shrink-0 bg-brand-gold/20 w-6 h-6 flex items-center justify-center rounded-full font-bold mt-0.5" data-id="element-109">
              ✅
            </div>
            <div data-id="element-110">
              <h3 className="text-sm font-bold leading-tight mb-0.5 text-brand-green" data-id="element-111">
                {module.title}
              </h3>
              <p className="text-brand-ink/80 text-xs leading-snug" data-id="element-112">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}